import { Popover, Table } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { MdMyLocation } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import filterImg from "../../../assets/images/filter.png";
import saleIcon from "../../../assets/images/saleIcon.png";
// import md1 from "../../../assets/images/staticImages/md1.png";
import md2 from "../../../assets/images/staticImages/md2.png";
import pf1 from "../../../assets/images/staticImages/pf.png";
import pf2 from "../../../assets/images/staticImages/pf1.png";
import pf3 from "../../../assets/images/staticImages/pf2.png";
import md3 from "../../../assets/images/staticImages/md3.png";
import dummyImg from "../../../assets/images/dummy.png";
import md1 from "../../../assets/images/imagePlaceholder.png";

import {
  Dropdown,
  Modal,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../components";
import BatteryStatus from "../../../components/battery/Battery";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import styles from "./lisenceManagement.module.css";
import { DatePicker, StaticDatePicker } from "@mui/x-date-pickers-pro";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { createTheme } from "@mui/material";
import {
  FaCaretDown,
  FaCaretLeft,
  FaCaretRight,
  FaCaretUp,
} from "react-icons/fa";
import { LuCalendarDays } from "react-icons/lu";
import { AssetsMiddleware } from "../../../Store/Middlewares/AssetsMiddleware";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import { showAlert } from "../../../Store/Actions/GeneralActions";

const LisenceManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef();
  const [extendModal, setExtendModal] = useState(false);
  const [date, setDate] = useState(dayjs());
  const [licenseDur, setLicenseDur] = useState("");
  const [details, setDetails] = useState(null);
  // console.log("licenseeeeeeee", licenseDur);

  const currentDate = new Date();
  const LICENSE = useSelector((state) => state.AssetsReducer.getLicense);

  useEffect(() => {
    dispatch(AssetsMiddleware.getlicense({ name: "" })).then((data) => {});
  }, []);

  const onSearch = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      dispatch(AssetsMiddleware.getlicense({ name: value })).then((data) => {});
    }, 1000);
  };

  const user = useSelector((state) => state.AuthReducer.user);
  const add_asset = user?.permissions?.find((x) => x?.name == "add_asset");

  const dummydata = [
    {
      id: 1,
      key: "01",
      module: { image: md1, name: "Phoenix Immobilizer N16" },
      owner: { image: pf1, name: "Stephanie Sharkey" },
      salesPerson: { image: pf3, name: "Oliver Johnson" },
      startDate: "Nov 12, 2024",
      endDate: "Nov 12, 2025",
      extend: "Extend",
    },
    {
      id: 2,
      key: "02",
      module: { image: md1, name: "Phoenix Immobilizer N16" },
      owner: { image: pf1, name: "Stephanie Sharkey" },
      salesPerson: { image: pf3, name: "Oliver Johnson" },
      startDate: "Nov 12, 2024",
      endDate: "Nov 12, 2025",
      extend: "Extend",
    },
    {
      id: 3,
      key: "03",
      module: { image: md1, name: "Phoenix Immobilizer N16" },
      owner: { image: pf1, name: "Stephanie Sharkey" },
      salesPerson: { image: pf3, name: "Oliver Johnson" },
      startDate: "Nov 12, 2024",
      endDate: "Nov 12, 2025",
      extend: "Extend",
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (text, data, index) => (
        <div>
          <TextComponent text={index + 1} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "Device",
      dataIndex: "module",
      key: "module",
      render: (item, data) => (
        <div className={styles.module} onClick={() => setOpen(true)}>
          <img
            src={data?.module_image ? data?.module_image : md1}
            className={styles.moduleImg}
          />
          <TextComponent
            text={data?.module_device_id ? data?.module_device_id : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "Owner",
      dataIndex: "owner",
      key: "owner",
      render: (item, data) => (
        <div className={styles.module1} onClick={() => setOpen(true)}>
          <img
            src={data?.owner_image ? data?.owner_image : dummyImg}
            className={styles.personImg}
          />
          <TextComponent
            text={data?.owner_name ? data?.owner_name : "--"}
            className={styles.persontext}
          />
        </div>
      ),
    },
    {
      title: "Sales Person",
      dataIndex: "salesPerson",
      key: "salesPerson",
      render: (item, data) => (
        <div className={styles.module1} onClick={() => setOpen(true)}>
          <img
            src={data?.sales_person_image ? data?.sales_person_image : dummyImg}
            className={styles.personImg}
          />
          <TextComponent
            text={data?.sales_person_name ? data?.sales_person_name : "--"}
            className={styles.persontext}
          />
        </div>
      ),
    },
    {
      title: "Start Date",
      dataIndex: "issue_date",
      key: "issue_date",
      render: (text) => (
        <div>
          <TextComponent text={moment(text).format("MMM DD, YYYY")} />
        </div>
      ),
    },
    {
      title: "End Date",
      dataIndex: "expiry_date",
      key: "expiry_date",
      render: (text) => (
        <div>
          <TextComponent text={moment(text).format("MMM DD, YYYY")} />
        </div>
      ),
    },
    {
      title: "Extend",
      dataIndex: "extend",
      key: "extend",
      render: (text, data) => {
        const isExtended = moment(currentDate).isAfter(
          moment(data?.expiry_date),
        );

        return (
          <div
            onClick={() => {
              if (data?.is_expired && user?.is_owner) {
                setExtendModal(true);
              }
              setDetails(data);
            }}
          >
            <TextComponent
              text={"Extend"}
              className={
                data?.is_expired && user?.is_owner
                  ? styles.extend
                  : styles.notextend
              }
            />
          </div>
        );
      },
    },
  ];
  const content = (
    <div className={styles.datePickerCont}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <StaticDatePicker
          value={date}
          onChange={(newValue) => {
            setDate(newValue);
          }}
          slotProps={{ actionBar: { actions: [] } }}
          slots={{
            leftArrowIcon: () => (
              <>
                <FaCaretLeft size={25} color="var(--secondary-color)" />
              </>
            ),

            rightArrowIcon: () => (
              <>
                <FaCaretRight size={25} color="var(--secondary-color)" />
              </>
            ),
            toolbar: (props) => {
              return <></>;
            },
          }}
        />
      </LocalizationProvider>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 0px",
        }}
      >
        <SubmitButton
          title="Cancel"
          secondaryBtn
          btnClass={styles.clearBtn}
          onClick={() => {
            setOpen(false);
          }}
        />
        <SubmitButton
          title="Extend"
          btnClass={styles.applyBtn}
          onClick={() => {
            setOpen(false);
            setExtendModal(false);
          }}
        />
      </div>
    </div>
  );
  return (
    <div className={styles.mainCont}>
      <div className={styles.header}>
        <TextComponent
          text={"License Management"}
          className={styles.headerHeading}
        />
        <div className={styles.rightHeader}>
          <SearchInput
            onChange={(e) => onSearch(e)}
            // rightIcon={<img src={filterImg} className={styles.filterIcon} />}
          />
        </div>
      </div>
      <div className={styles.tableDiv}>
        <Table
          //   title={}
          scroll={{ x: true }}
          bordered={false}
          pagination={false}
          columns={columns}
          dataSource={LICENSE}
          onRow={(record, rowIndex) => {
            return {
              //   onClick: () => setDetails(record),
            };
          }}
        />
        <Modal
          open={extendModal}
          onCancel={() => {
            setExtendModal(false);
            setDetails(null);
          }}
          title={"Extend"}
          width={400}
          buttonTitle={"Extend"}
          onBtnPress={() => {
            if (!licenseDur) {
              dispatch(
                showAlert({
                  type: "Error",
                  message: "Select license duration ",
                }),
              );
            } else {
              dispatch(
                AssetsMiddleware.extendLicense({ id: details?.id, licenseDur }),
              );
              setExtendModal(false);
            }
          }}
          headingClass={styles.modalHeading}
          btnStyle={{ width: "100%", backgroundColor: "var(--primary-color)" }}
          textStyle={{ color: "var(--white-color)" }}
        >
          <Dropdown
            label={"License Duration"}
            className={styles.access_modalInput}
            value={licenseDur ? licenseDur : "Select Duration"}
            onChange={(e) => setLicenseDur(e?.value)}
            options={[
              { id: 1, value: "1 years" },
              { id: 1, value: "3 years" },
              { id: 1, value: "5 years" },
              { id: 1, value: "7 years" },
            ]}
          />
          {open && content}
        </Modal>
      </div>
    </div>
  );
};

export default LisenceManagement;
